import { useMemo } from 'react';
import { useQuery, QueryOptions } from 'react-query';

import ResidentService from '../../services/residentService';
import useAbortController from '../../hooks/useAbortController';

const placeholderData = { rows: [], count: 0 };

const useResidentScreeningsQuery = ({
  organizationId,
  propertyId,
  residentId,
  householdId,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  residentId: string,
  householdId: string,
  options?: QueryOptions,
}) => {
  const residentService = useMemo(() => new ResidentService(), []);
  const abortControllerOptions = useAbortController();

  return useQuery(
    [
      'getResidentScreenings',
      organizationId,
      propertyId,
      residentId,
      householdId,
    ],
    () =>
      residentService.getResidentScreenings(
        organizationId,
        propertyId,
        residentId,
        householdId,
        abortControllerOptions,
      ),
    {
      refetchOnWindowFocus: false,
      placeholderData,
      ...options,
    },
  );
};

export default useResidentScreeningsQuery;
